import AccessibilityCertification from '@components/Images/Certifications/AccessibilityCertification';
import { StudioDesignLeagueCertification } from '@components/Images/Certifications/StudioDesignLeagueCertification';
import DeveloperCertification from '@components/Images/Certifications/StudioDevCertification';
import { StudioDevWebsitesLeagueCertification } from '@components/Images/Certifications/StudioDevWebsitesLeagueCertification';
import VeloCertification from '@components/Images/Certifications/VeloCertification';
import WebDesignerCertification from '@components/Images/Certifications/WebDesignerCertification';
import { CertificationType } from '@wix/ambassador-academy-certifications-v1-account-certification/types';
import React from 'react';

export const CertificationTypeToRenderDetails: Record<
  CertificationType,
  { Component: React.FC | null; label: string }
> = {
  [CertificationType.ACCESSIBILITY]: {
    Component: AccessibilityCertification,
    label: 'profile-page-certifications-accessibility',
  },
  [CertificationType.STUDIO_DEVELOPER]: {
    Component: DeveloperCertification,
    label: 'profile-page-certifications-studio-developer',
  },
  [CertificationType.WEB_DESIGNER]: {
    Component: WebDesignerCertification,
    label: 'profile-page-certifications-web-designer',
  },
  [CertificationType.VELO]: {
    Component: VeloCertification,
    label: 'profile-page-certifications-velo-developer',
  },
  [CertificationType.STUDIO_DESIGN_LEAGUE]: {
    Component: StudioDesignLeagueCertification,
    label: 'profile-page-certifications-studio-design-league',
  },
  [CertificationType.STUDIO_DEV_WEBSITES_LEAGUE]: {
    Component: StudioDevWebsitesLeagueCertification,
    label: 'profile-page-certifications-studio-dev-websites-league',
  },
  [CertificationType.UNKNOWN]: { Component: null, label: '' },
};
